import React, { useEffect } from "react";
import FlowBuilder from "../FlowBuilder/FlowBuilder";
import { useSelector } from "react-redux";
import AutomatedRN from  "./AutomateRNDtata.json"

function AutomateFlows() {
  const [loading, setLoading] = React.useState(false);
  const [showFlowDiv, setShowFlowDiv] = React.useState(false);
  const EmpId = useSelector((state: any) => state.authApiSlice.Id);
  const [appRNData, setAppRNData] = React.useState<any>(AutomatedRN);
  const [appFlowData, setAppFlowData] = React.useState<any>([]);
  const ActiveClient = useSelector(
    (state: any) => state.clientDetails.activeClient
  );

  useEffect(() => {
    setAppRNData(AutomatedRN);
  }, []);


  const handleUpdateAppFlow = (data: any) => {
    console.log("handleAUTOMATEFlow--->",  data);
  };

  return (
    <>
        <FlowBuilder
          load_Flow_Data={false}
          data={ActiveClient}
          flowRNData={appRNData}
          flowData={appFlowData}
          handleSubmitFlow={(data: any) => {
            handleUpdateAppFlow(data);
          }}
          getFlowByEnv={(Env_Id: number) => {
            
          }}
        />
    </>
  );
}

export default AutomateFlows;
